import { connect } from 'react-redux';
import { ReviewBlock } from './ReviewBlock';
import {
  getHotelExpertReviewDescription,
  getHotelExpertReviewExpertAvatar,
  getHotelExpertReviewExpertName,
  getHotelExpertReviewExpertRegalia,
  getHotelExpertReviewTitle,
} from '../../store/hotel';

const mapStateToProps = (state) => ({
  title: getHotelExpertReviewTitle(state),
  description: getHotelExpertReviewDescription(state),
  avatarImages: getHotelExpertReviewExpertAvatar(state),
  avatarName: getHotelExpertReviewExpertName(state),
  avatarDescription: getHotelExpertReviewExpertRegalia(state),
});

export default connect(mapStateToProps)(ReviewBlock);
